
const digest = '5f04cde667d28b8eb6696c361897d689cb34ccb50e5c5387e7b2700b099e2099';
const classes = {"wrapper":"_wrapper_1nudw_1","childrenWrapper":"_childrenWrapper_1nudw_7","item":"_item_1nudw_14","content":"_content_1nudw_36","control":"_control_1nudw_44","workplace":"_workplace_1nudw_49","folder":"_folder_1nudw_52","indent":"_indent_1nudw_57","label":"_label_1nudw_62","icon":"_icon_1nudw_69","folderIcon":"_folderIcon_1nudw_73"};
const css = `._wrapper_1nudw_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_1nudw_1 ._childrenWrapper_1nudw_7 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-left: 20px;
  margin-left: 35px;
}
._wrapper_1nudw_1 ._childrenWrapper_1nudw_7 ._item_1nudw_14:before {
  content: "";
  height: 55%;
  width: 15px;
  border-left: 1px solid #c6c6c6;
  border-bottom: 1px solid #c6c6c6;
  position: absolute;
  left: -20px;
  top: 0;
}
._wrapper_1nudw_1 ._item_1nudw_14 {
  padding: 12px;
  background-color: #ffffff;
  border: 1px solid #d1d4da;
  border-radius: 3px;
  font-weight: 500;
  font-size: 14px;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
._wrapper_1nudw_1 ._item_1nudw_14 ._content_1nudw_36 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  flex: 1;
  align-items: center;
  padding: 12px;
}
._wrapper_1nudw_1 ._item_1nudw_14 ._control_1nudw_44 {
  display: flex;
  align-items: center;
  padding-right: 12px;
}
._wrapper_1nudw_1 ._item_1nudw_14._workplace_1nudw_49 {
  color: #1665d8;
}
._wrapper_1nudw_1 ._item_1nudw_14._folder_1nudw_52 {
  background-color: #fbfbfd;
  color: #000000;
}

._indent_1nudw_57 {
  width: 27px;
  flex: 0 0 27px;
}

._label_1nudw_62 {
  display: flex;
  align-items: center;
  flex-direction: row;
  flex: 1;
}

._icon_1nudw_69 {
  margin-right: 10px;
}

._folderIcon_1nudw_73 {
  vertical-align: middle;
  border-style: none;
  margin-right: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  